var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("pharmacists-dialog", {
    attrs: {
      title: "Freiberufler Negativ-Liste bearbeiten",
      activePharmacists: _vm.activePharmacists,
      savedPharmacistIds: _vm.blacklistIds,
    },
    on: { save: _vm.submit },
    model: {
      value: _vm.isOpen,
      callback: function ($$v) {
        _vm.isOpen = $$v
      },
      expression: "isOpen",
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }